import React, { Component } from 'react';
import { Link } from "react-router-dom";
import './end.css'
import Leafs from '../../components/leafs';
import ReactGA from 'react-ga';

class End extends Component {
  state = {
    animated: false
  }

  componentDidMount() {

    ReactGA.pageview(window.location.pathname + window.location.search);

    setTimeout(()=>{
      this.setState({animated: true})
    }, 200)
  }

  render() {
    const { animated } = this.state

    return (
      <div>
        <Leafs></Leafs>

        <div className={`end__page ${animated ? 'animated' : ''}`}>
          <h2>Гол! Твоя открытка в розыгрыше путешествия!</h2>
          <p>Чем больше ты&nbsp;делишься, тем больше шансов на&nbsp;победу! Генерируй праздничное настроение - поздравляй футбольными открытками своих близких, друзей и&nbsp;коллег. До&nbsp;15 марта мы&nbsp;подведем итоги конкурса и&nbsp;назовем имя победителя на&nbsp;нашем сайте!</p>
          <Link className="button" to="card">Сделать еще</Link>
          <div className="card__note -mobile">*В розыгрыше могут принимать участие пользователи старше 18 лет</div>

        </div>
      </div>
    );
  }
}

export default End;